import { render } from "./VendorCenter.vue?vue&type=template&id=44aad1e2"
import script from "./VendorCenter.vue?vue&type=script&lang=js"
export * from "./VendorCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__